import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { requestCreateSpecification, requestUpdateClassification } from '../../../../api/product/product.actions';

import ProductClassificationModal from '../../../../components/screens/admin/product-specifications/product-classification-modal/ProductClassificationModal';

const ProductClassificationModalContainer = ({
  show,
  setShow,
  filters,
  retrieveSpecifications,
  retrieveClassifications,
}) => {
  const dispatch = useDispatch();

  const createClassification = (classification, onSuccess) => {
    dispatch(
      requestCreateSpecification({
        specification: classification,
        onSuccess: () => {
          retrieveClassifications();
          onSuccess();
        },
      })
    );
  };

  const updateClassification = (classification, onSuccess) => {
    dispatch(
      requestUpdateClassification({
        classification,
        onSuccess: () => {
          retrieveSpecifications(filters);
          retrieveClassifications();
          onSuccess();
        },
      })
    );
  };

  return (
    <ProductClassificationModal
      show={show}
      setShow={setShow}
      createClassification={createClassification}
      updateClassification={updateClassification}
    />
  );
};

ProductClassificationModalContainer.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  retrieveSpecifications: PropTypes.func.isRequired,
  retrieveClassifications: PropTypes.func.isRequired,
};

export default ProductClassificationModalContainer;
